// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-user-agreement[data-v-301d431f]{width:100%;min-height:100vh;background:#fff}.container-user-agreement .main[data-v-301d431f]{padding:0 16px 16px 16px;color:#666;line-height:20px}", ""]);
// Exports
module.exports = exports;
